import { makeAutoObservable } from 'mobx';

export class Utils {
  private emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  private contactNumberRegex = new RegExp("^\\+?(\\d{1,4})?[\\s-]?(\\(?\\d+\\)?[\\s-]?)*\\d{3,4}$"); 
  private postcodeRegex = /^([A-Za-z]{2}\d{1,2}[A-Za-z]?)\s+(\d[A-Za-z]{2})$/;

  get apiBaseUrl(): string {
    const env = (window as any).__ENV__ || {};
    return (
      env.API_BASE_URL ||
      process.env.REACT_APP_API_BASE_URL
    );
  }

  get stripePublicKey(): string {
    const env = (window as any).__ENV__ || {};
    return (
      env.STRIPE_PUBLIC_KEY ||
      process.env.STRIPE_PUBLIC_KEY
    );
  }

  saveToLocalStorage(key: string, data: string) {
    localStorage.setItem(key, data);
  }

  saveToSessionStorage(key: string, data: string) {
    sessionStorage.setItem(key, data);
  }

  loadFromLocalStorage(key: string) {
    const data = localStorage.getItem(key);
    if (data) {
      return data;
    }

    return null;
  }

  loadFromSessionStorage(key: string) {
    const data = sessionStorage.getItem(key);
    if (data) {
      return data;
    }

    return null;
  }

  removeFromLocalStorage(key: string) {
    localStorage.removeItem(key)
  }

  removeFromSessionStorage(key: string) {
    sessionStorage.removeItem(key)
  }

  setCookie(name: string, value: string, days: number) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  loadFromCookie(name: string) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  removeCookie(name: string) {
    document.cookie = name + '=; Max-Age=-99999999;';
  }

  callbackIn(milliseconds: number, callback: () => void) {
    return new Promise(_ => setTimeout(() => {
      callback()
    }, milliseconds));
  }

  emailCorrect(email: string) {
    return this.emailRegex.test(email)
  }

  phoneNumberCorrect(phoneNumber: string) {
    return this.contactNumberRegex.test(phoneNumber)
  }

  postcodeCorrect(postcode: string) {
    return this.postcodeRegex.test(postcode)
  }

  roundAwayFromZero(value: number, decimals = 2) {
    const factor = Math.pow(10, decimals);
    const scaled = value * factor;

    if (Math.abs(scaled % 1) === 0.5) {
      return (Math.sign(scaled) * (Math.floor(Math.abs(scaled)) + 1)) / factor;
    }

    return Math.round(scaled) / factor;
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const utils = new Utils();